import { gql } from '@apollo/client';
import { TaskType } from '../../types';

export const GET_SHIP_TO_HERE_TASK_LIST = gql`
    query GetShipToHereTaskList($filter: TmsTaskFiltersInput, $pageRequest: PageRequestTypeInput) {
        getShipToHereTaskList(filters: $filter, pageRequest: $pageRequest) {
            content {
                id
                taskNumber
                taskType
                businessType
                taskDate
                taskStatus
                routeId
                routeName
                routeCode
                routeType
                warehouseId
                planDepartureDate
                planDepartureTime
                planDepartureAt
                planDepartureTimezone
                actualDepartureDate
                actualDepartureTime
                actualDepartureAt
                actualDepartureTimezone
                planArrivalDate
                planArrivalTime
                planArrivalAt
                planArrivalTimezone
                actualArrivalDate
                actualArrivalTime
                actualArrivalAt
                actualArrivalTimezone
                vehicleEstimatedArrivalDate
                vehicleEstimatedArrivalTime
                vehicleEstimatedArrivalAt
                vehicleEstimatedArrivalTimezone
                originTimezone
                destinationTimezone
                currentStation
                currentWaypointStatus
                carrierId
                carrierName
                driverId
                driverName
                vehicleId
                licensePlate
                vehicleModel
                vehicleTypeId
                vehicleTypeName
                escortCount
                gpsTracking
                bolNumber
                perVehicleCost
                remark
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface ShipToHereTaskType extends TaskType {}

export interface TmsTaskFiltersInput {
    taskType?: number;
    routeId?: number;
    routeCode?: string;
    taskNumber?: string;
    taskStatus?: number;
    taskStatuses?: number[];
    routeType?: number;
    scheduleId?: number;
    carrierId?: number;
    driverId?: number;
    vehicleId?: number;
    warehouseId?: number;
    taskDateStart?: string;
    taskDateEnd?: string;
}

export interface ShipToHereTaskListResponse {
    getShipToHereTaskList: ShipToHereTaskListResponseType;
}

export interface ShipToHereTaskListResponseType {
    content: ShipToHereTaskType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}
